import { HttpService } from '../../common/api/httpService';
import { ParserInfo } from '../../models/parser';
import { RequestResult, RequestResultValue } from '../../common/api/requestResult';
import JSONbig from 'json-bigint';

const JSONbigNative = JSONbig({ useNativeBigInt: true });

export async function getParserInfo(count: number): Promise<RequestResultValue<ParserInfo>> {
    try {
        const response = await HttpService.getBSInstance().requestGetAsync(`v1/parser/state?count=${count}`);
        const text = await response.text();
        const body = JSONbigNative.parse(text);
        if (response.status >= 200 && response.status < 300) {
            return new RequestResultValue<ParserInfo>(true, body as ParserInfo);
        }
        return new RequestResultValue<ParserInfo>(false);
    } catch (e) {
        return new RequestResultValue<ParserInfo>(false);
    }
}

export async function setParserState(appId: number, state: number): Promise<RequestResult> {
    try {
        const response = await HttpService.getBSInstance().requestPostAsync(`v1/parser/state`, JSONbig.stringify({ gameId: appId, state }));
        if (response.status >= 200 && response.status < 300) {
            return new RequestResult(true);
        }
        return new RequestResult(false, `HTTP ${response.status}`);
    } catch (e: any) {
        return new RequestResult(false, e?.message || 'Network error');
    }
}


